import { render, staticRenderFns } from "./OrderLayoutResponses.vue?vue&type=template&id=312897d3&scoped=true"
import script from "./OrderLayoutResponses.vue?vue&type=script&lang=js"
export * from "./OrderLayoutResponses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312897d3",
  null
  
)

export default component.exports